import { getResourceAllocations } from "../../../actions/timesheet.action";
import moment from "moment";
import { updateProjectAction } from "../../../slice/project-detail";
import _ from "lodash";
import { getUserList } from "../../../actions/user-management.action";

export const getWorkAllocationsData = async ({ projectId, dispatch }) => {

    let timeSpentProgress = 0, timeAllocated = 0;
    let params = { projectId, updateTaskAllocation: true, };
    const resourceAllocations = await dispatch(getResourceAllocations(params));
    const userIds = _.uniq((Array.isArray(resourceAllocations) && resourceAllocations.map(({ userId }) => userId)) || []);
    const list = await dispatch(getUserList({ userIds }));
    let usersTimesheets = [];

    // Pre-process resourceAllocations into a map for faster lookups
    const userAllocationsMap = new Map();
    if (Array.isArray(resourceAllocations)) {
        resourceAllocations.forEach(allocation => {
            if (!userAllocationsMap.has(allocation.userId)) {
                userAllocationsMap.set(allocation.userId, []);
            }
            userAllocationsMap.get(allocation.userId).push(allocation);
        });
    }

    list.forEach(({ id }) => {
        // Get allocations directly from the map, defaulting to an empty array
        const usersTimesheet = userAllocationsMap.get(id) || [];
        usersTimesheets.push(...usersTimesheet);
    });

    usersTimesheets.forEach((item) => {
        const approvedStart = moment(item.approvedStartTime);
        const approvedEnd = moment(item.approvedEndTime);

        const _approvedHrs = moment.duration(approvedEnd.diff(approvedStart)).asHours();
        if (item.status === 'PENDING') {
            const allocatedStartTime = moment(item.startTime);
            const allocatedEndTime = moment(item.endTime);
            const allocatedHrs = moment.duration(allocatedEndTime.diff(allocatedStartTime)).asHours();
            timeAllocated += allocatedHrs;
        }
        if (item.status === 'APPROVED') {
            timeAllocated += _approvedHrs;
            timeSpentProgress += _approvedHrs;
        }
    });

    // timeSpentProgress = Math.floor((timeSpentProgress / 1000 / 60 / 60) % 24);
    // timeSpentProgress = Math.floor((timeSpentProgress / 1000 / 60 / 60));
    timeAllocated = Math.floor(timeAllocated) + ":" + parseInt((timeAllocated * 60) % 60);
    timeSpentProgress = Math.floor(timeSpentProgress) + ":" + parseInt((timeSpentProgress * 60) % 60);
    dispatch(updateProjectAction({ timeSpentProgress }))
    return { timeSpentProgress, timeAllocated };

};